import { ISurveyStandardQuestion } from '../interfaces/ISurveyStandardQuestion';

/** The standard survey's three questions live at steps 0, 1 and 2; step 3 is the outro / comment page. */
export const STANDARD_SURVEY_LAST_QUESTION_STEP = 2;

/**
 * True when answering the third question ends the survey, false when it leads to the comment page.
 *
 * 770271: this used to be derived by comparing the rendered button label against `t('send')`, which made
 * the label a control-flow input — relabelling the button silently dropped positive respondents onto the
 * negative comment page. The predicate and the label must stay independent.
 */
export const standardSurveyEndsAfterLastQuestion = (
  questions: ISurveyStandardQuestion[],
  scoreThreshold: number,
  feedbackActive?: boolean
): boolean => {
  if (!feedbackActive) {
    return true;
  }

  const answeredYes = questions[2]?.answer === 1;
  const reachedThreshold =
    scoreThreshold <= (questions[0]?.answer ?? 0) + (questions[1]?.answer ?? 0);

  return answeredYes && reachedThreshold;
};
